export interface AccountFree {
  canShowButton: boolean
  canTranscribe: boolean
  dateReplacements: any[]
  description: string[]
  freeTrialExpired: boolean
  inGodMode: boolean
  isInFreeTrial: boolean
  isInstitution: boolean
  isInstitutional: boolean
  isMinor: boolean
  isOnReferralUnlimited: boolean
  isPaid: boolean
  isTemporaryUnlimited: boolean
  isUpgradable: boolean
  isVIP: boolean
  name: string
  primaryEmailAddress: string
  productEnum: string
  productName: string
  referralEvents: any[]
  totalMotesMade: number
  userId: string
  validFrom: number
  wasPaid: boolean
}

export interface AccountFreeTrial extends AccountFree {
  freeTrialExpiryEpoch: number
  postTemporaryProductName: string
  temporaryUnlimitedEpoch: number
}

export interface AccountPaid extends AccountFree {
  hasPaymentExpired: boolean
  paymentInfoAvailableFromProvider: boolean
  planExpiryEpoch: number
  planName: string
}

export interface AccountB2BCurrentLicense {
  bonusEssentialUsers: number
  canAddEssential: boolean
  canAddEssentialFreeMinors: boolean
  canAddHighestProductEnumUsers: boolean
  canAddUnlimited: boolean
  hasStaffStudentBreakdown: boolean
  highestProductEnum: string
  isActive: boolean
  paidEssential: number
  paidUnlimited: number
  subscriptionValidUntil: number
  totalPaidSeats: number
  totalUsers: number
  unusedPaidSeats: number
  usedEssential: number
  usedUnlimited: number
}

export interface AccountB2BInstitution {
  analyticsEmbedCode: string
  institutionId: string
}

export interface AccountB2BCommon extends AccountPaid {
  accountOwnerEmail: string
  accountOwnerName: string
  accountPureAdminEmails: string[]
  analyticsEmbedCode: string
  currentLicense: AccountB2BCurrentLicense
  enableFallbackUnlimitedDomain: boolean
  enableForcedMinorEssentialDomain: boolean
  enableForcedMinorUnlimitedDomain: boolean
  fallbackUnlimitedDomain: string
  forcedMinorEssentialDomain: string
  forcedMinorUnlimitedDomain: string
  fullName: string
  institution: AccountB2BInstitution
  institutionCountryCode: string
  institutionId: string
  institutionName: string
  institutionProductSummary: string
  institutionRegion: string
  totalPaidSeats: number
  totalUsedSeats: number
}

export interface AccountB2BOwner extends AccountB2BCommon {
  institutionalRole: 'Owner'
  isInstitutionalAdmin: true
  isInstitutionalOwner: true
}

export interface AccountB2BAdmin extends AccountB2BCommon {
  institutionalRole: 'Admin'
  isInstitutionalAdmin: true
  isInstitutionalOwner: false
}

export type AccountB2B = AccountB2BOwner | AccountB2BAdmin

export type Account = AccountFree | AccountFreeTrial | AccountPaid | AccountB2B

export function isB2BAccount(account: Account): account is AccountB2B {
  return account.isInstitutional
}

export function isB2BAdmin(account: Account): account is AccountB2BAdmin {
  return (
    isB2BAccount(account) &&
    'isInstitutionalAdmin' in account &&
    account.isInstitutionalAdmin
  )
}
